inputMixin =
    props: field: type: String

    data: ->
        focused: false

    computed:
        value:      -> @$root.form[@field]
        label:      -> @value.label
        note:       -> @value.note
        selected:   -> @focused or @value.value
        compulsory: -> @value.compulsory

    methods:
        focus: -> do @$refs.input.focus

Vue.component 'form-input',
    mixins: [inputMixin]
    template: """
<div :id="field" @click='focus'>
    <label :class="{selected: selected || isDate, compulsory: compulsory}">
        {{label}} {{note}}
    </label>
    <input ref='input'
           :type='type'
           min='0'
           @focus="focused = true"
           @blur="focused = false"
           v-model="value.value">
    <slot></slot>
</div>
"""
    props: type:  default: 'text'

    data: -> isDate: @type is 'date'

Vue.component 'form-password',
    mixins: [inputMixin]
    template: """
<div :id="field" @click='focus'>
    <label ref='input'
           class='compulsory'
           :class="{selected: selected}">
        {{label}}
    </label>
    <input type="text"
           style='margin-bottom: 15px'
           @focus="focused = true"
           @blur="focused = false"
           v-model="value.value">
    <div style='text-align: center;'>
        <button class='primary-button button-sm'
                @click="makePassword">
            Generate
        </button>
        <button class='primary-button button-sm'
                :disabled='!value.value'
                @click="toClipboard">
            {{copyLabel}}
        </button>
    </div>
</div>
"""
    props: value:  default: 'text'

    data: -> copyLabel: 'Copy'

    methods:
        makePassword: ->
            chars = "1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM"
            pass = []
            for j in [0...12]
                pos = Math.floor(Math.random() * chars.length)
                pass.push chars[pos]
            @value.value = pass.join ''

        toClipboard: ->
            navigator.clipboard.writeText @value.value
            @copyLabel = 'Copied!'
            setTimeout (=> @copyLabel = 'Copy'), 2000

Vue.component 'form-select',
    mixins: [inputMixin]
    template: """
<div :id="field">
    <label :class="{selected: selected, compulsory: compulsory}">
        {{label}}
    </label>
    <select ref='input'
            @focus="focused = true"
            @blur='focused = false'
            v-model="value.value">
        <option value=''></option>
        <option v-for='cc, name in list'
                :value='cc'>
            {{name}}
        </option>
    </select>
</div>
"""
    props: ['list']

Vue.component 'form-filter-select',
    mixins: [inputMixin]
    template: """
<div :id="field">
    <label style='z-index: 1'
        :class="{selected: selected, compulsory: compulsory}">
        {{label}}
    </label>
    <multiselect ref='input'
                 :class='{"form-dropdown": !focused}'
                 @open="focused = true"
                 @close="focused = false"
                 v-model="value.value"
                 track-by="value" label="option"
                 placeholder=""
                 :options="list"></multiselect>
</div>
"""
    props: ['list']


Vue.component 'form-textarea',
    mixins: [inputMixin]
    template: """
<div :id="field">
    <label :class="{selected: selected, compulsory: compulsory}">
        {{label}}
    </label>
    <textarea ref='input'
              @focus="focused = true"
              @blur='focused = false'
              :rows="rows"
              v-model="value.value"
              :placeholder="focused? note: ''"
              class="form-control"></textarea>
        <slot></slot>
</div>
"""
    props:
        placeholder: type: String
        rows: default: 5

Vue.component 'form-list',
    template: """
<div>
    <h4>{{label}}</h4>
    <ul class='form-list'>
        <li v-for='input, key in list'
            @click='input.value = !input.value'
            :class='{selected: input.value}'>
            {{input.label}}
        </li>
        <li class='other' v-if='!skipOther'>
            <textarea class="form-control"
                      rows='4'
                      v-model="value.other"
                      placeholder="Other, one per line..."></textarea>
        </li>
    </ul>
    <slot></slot>
</div>
"""
    props:
        field: type: String
        skipOther: type: Boolean

    computed:
        value: -> @$root.form[@field]
        label: -> @value['listLabel']
        list: -> @value['formList']


Vue.component 'form-toggle',
    template: """
<div class='form-toggle'>
    <span class="toggle-label"
        :class="{selected: value.value}">
        {{labelOn}}
    </span>
    <div class="toggle"
         @click="value.value = !value.value"
         :class="{toggled: !value.value}"></div>
    <span class="toggle-label"
        :class="{selected: !value.value}">
        {{labelOff}}
    </span>
    <small>{{label}}</small>
    <slot></slot>
</div>
"""
    props: ['value', 'labelOn', 'labelOff', 'note']

    computed:
        label:-> @note or @value.label
